export default __webpack_public_path__ + "static/media/background-login.02b93d05.jpg";